export default "__VITE_ASSET__BuBZxsDc__"